/** Resolve app role from profile row and/or Supabase user_metadata. */
export function getUserRole(user) {
    if (!user) return null;
    return user.role || user.user_metadata?.role || null;
}

export function isPortalUser(user) {
    return getUserRole(user) === 'portal';
}

export function isTeacherUser(user) {
    return getUserRole(user) === 'teacher';
}

export function isStudentUser(user) {
    const role = getUserRole(user);
    return role === 'student' || (!role && !!user);
}
